import React from 'react';
import { Flex, rem, Text, ThemeIcon } from '@mantine/core';
import { useContent } from '@/providers/ContentProvider';
import { removeWhiteSpaces } from '@/utils/utilities';
import { IconPhone, IconMail } from '@tabler/icons-react';

const baseSlug = 'contactBoxes.';

export const ContactBoxes: React.FC = () => {
	const { getContent, language } = useContent();

	return (
		<>
			<Flex mb="lg" gap="md" wrap="wrap">
				<a
					href={`tel:${removeWhiteSpaces('48 609 058 683')}`}
					className="decoration-none"
				>
					<Flex gap="sm" align="center">
						<ThemeIcon variant="light" size={30}>
							<IconPhone style={{ width: rem(18), height: rem(18) }} />
						</ThemeIcon>
						<Text fw="bold">+48 609 058 683</Text>
					</Flex>
				</a>
				<a href="mailto:zczlapa@leon.eu" className="decoration-none">
					<Flex gap="sm" align="center">
						<ThemeIcon variant="light" size={30}>
							<IconMail style={{ width: rem(18), height: rem(18) }} />
						</ThemeIcon>
						<Text fw="bold">zczlapa@leon.eu</Text>
					</Flex>
				</a>
			</Flex>
		</>
	);
};
